import { getFocusedInboxRollupStore } from "owa-mail-focused-inbox-rollup-store";
import type FocusedViewFilter from "owa-service/lib/contract/FocusedViewFilter";
import { getFocusedFilterForTable, getSelectedTableView, isPriorityView, isNeedsReplyView } from "owa-mail-list-store";
import { getMailboxInfo } from "owa-mail-mailboxinfo";
import { isPrioritizeOnDemandOn } from "owa-copilot-settings-utils";
import type { MailFolderTableQuery } from "owa-mail-list-store";

/**
 * Determines whether to show Focused/Other rollup in mail list.
 */
export default function shouldShowFocusedRollup(): boolean {
    const tableView = getSelectedTableView();
    const mailboxInfo = tableView ? getMailboxInfo(tableView) : null;
    
    if (!mailboxInfo) {
        return false;
    }
    
    const focusedInboxRollupStore = getFocusedInboxRollupStore(mailboxInfo);
    if (!focusedInboxRollupStore.uniqueSenders) {
        return false;
    }
    
    // Don't show F/O roll up in case of FocusedViewFilter.None.
    if (getFocusedFilterForTable(tableView) === -1) {
        return false;
    }
    
    if (isPrioritizeOnDemandOn(mailboxInfo) &&
        isPriorityView(tableView?.tableQuery as MailFolderTableQuery)) {
        return false;
    }
    
    if (isNeedsReplyView(tableView?.tableQuery as MailFolderTableQuery)) {
        return false;
    }
    
    return true;
}
